import React from 'react'
import PropTypes from 'prop-types'
import { compose, setDisplayName, shouldUpdate } from 'recompose'
import { noop, isNil, isEqual } from 'lodash'

import { FormBlock } from 'components/formBlock/FormBlock'
import { formatValue } from 'utils/formatters/value'
import { Input } from 'components/input/Input'

import styles from './FormInput.module.scss'

const FormInputView = ({
  field,
  title,
  size,
  placeholder,
  isReadonly,
  isDisabled,
  isRequired,
  showErrorText,
  onChange,
  handleFieldChange,
  className,
  inputClassName,
  ...props
}) => {
  const handleChange = onChange ? onChange : handleFieldChange ? handleFieldChange(field.name) : noop
  const isRequiredField = isNil(isRequired) ? field.isRequired : isRequired

  return (
    <FormBlock
      title={title}
      readonlyView={formatValue(field.value)}
      isReadonly={!!isReadonly}
      isRequired={!!isRequiredField}
      className={className}>
      <Input
        className={inputClassName}
        inputClassName={styles.formInput}
        onChange={handleChange}
        value={field.value || ''}
        placeholder={placeholder}
        error={field.error}
        size={size}
        disabled={isDisabled}
        showErrorText={showErrorText}
        {...props}
      />
    </FormBlock>
  )
}

FormInputView.propTypes = {
  field: PropTypes.object.isRequired,
  title: PropTypes.node,
  size: PropTypes.string,
  placeholder: PropTypes.node,
  isDisabled: PropTypes.bool,
  isReadonly: PropTypes.bool,
  isRequired: PropTypes.bool,
  showErrorText: PropTypes.bool,
  onChange: PropTypes.func,
  className: PropTypes.string,
  inputClassName: PropTypes.string,
  handleFieldChange: PropTypes.func,
}

export const FormInput = compose(
  setDisplayName('FormInput'),
  shouldUpdate((props, nextProps) => !isEqual(props, nextProps)),
)(FormInputView)
